export const business = {
  name: "Chacon's Lawncare",
  // Every "Get Your Quote" button opens the Christmas decoration estimate request form.
  quoteHref: '/christmas-lights#christmas-estimate',
};
